function toNumber(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function round2(n) {
  return Math.round(toNumber(n) * 100) / 100;
}